"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'conversations.date.today': 'Today',
    'conversations.date.yesterday': 'Yesterday',
    'conversations.date.daysAgo': '{days} days ago',
};
